(ns iris.search.route-data
  (:require
   [iris.search.events :as search-events]))


(defn header-search-query-params [_db route]
  (let [query-params (or (get-in route [:route :query-params]) {})]
    {:q     (or (:q query-params) "")
     :ws    (or (:ws query-params) "TLO")
     :limit (or (:limit query-params) 50)
     :page  (or (:page query-params) 1)}))


(defn header-search-load-key [query-params]
  query-params)


(defn header-search-effects [{:keys [q] :as query-params}]
  (if (empty? q)
    [[::search-events/clear-header-search]]
    [[::search-events/header-search query-params]]))


(def panel-loaders
  {:header-search-panel
   {:params-fn   header-search-query-params
    :load-key-fn header-search-load-key
    :effects-fn  header-search-effects}})
